import React, { Component } from 'react';
import { connect } from 'react-redux';
import './App.css';
import Layout from './components/layout';
import Screen from './components/screen';
// eslint-disable-next-line
import rtep from './rtep';

class App extends Component {

  render() {
    const { screens, loading } = this.props;
    const style = {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh'
    }
    return (
      <div className="App" style={style}>
        <Layout />
        {screens.loading && loading && <Screen screen='loading' showCloseButton={false} />}
        {screens.modelSets && <Screen screen='modelSets' />}
        {screens.setCard && <Screen screen='setCard' />}
        {screens.order && <Screen screen='order' />}
        {screens.categoryData && <Screen screen='categoryData' />}
      </div>
    );
  }
}

App = connect(
  // state => ({ screens: state.ui.screens })
  state => {
    const { screens } = state.ui;
    const { category, models, sets, accessories, pictures, orders } = state.ui.loading;
    const loading = !category || !models || !sets || !accessories || !orders || !pictures;
    return { screens,loading };
  }
)(App);

export default App;



// WEBPACK FOOTER //
// ./src/App.js